<script>
const url = "http://img4.yishouapp.com";

// 区分开发测试环境的全局cookie 设置变量
const environment =
  process.env.NODE_ENV === "development" ||
  (window.location.host !== "erp.yishouapp.com" &&
    window.location.host !== "erpweb.yishouapp.com")
    ? 0
    : 1;

export default {
  environment,
  origin: url,
};
</script>



// WEBPACK FOOTER //
// src/components/Global.vue